import {BaseObject} from './BaseObject';
import {DocumentCompanyAccount} from './DocumentCompanyAccount';

export class DocumentCompany extends BaseObject {

    id: number;
    name: string;
    street: string;
    city: string;
    zip: string;
    companyNumber: string;
    varNumber: string;
    accounts: DocumentCompanyAccount[] = [];

}



// WEBPACK FOOTER //
// /app/src/model/Entities/DocumentCompany.ts